import { gql } from '@apollo/client';

export default gql`
  query productPrice($partnerLocationId: ID!, $productId: ID!) {
    productPrice(partnerLocationId: $partnerLocationId, productId: $productId)
  }
`;
